import Modal from "src/components/common/Modal";
import ModifierItemForm from "./ModifierItemForm";
import { ManageModifierItemModalProps } from "src/interfaces/modifier-items-props.interface";

const ManageModifierItemModal = ({
  modifierItemToEdit,
  isModifierItemModalOpen,
  handleCloseModifierItemModal,
}: ManageModifierItemModalProps) => {
  
  const modifierItemModalTitle = modifierItemToEdit ? "Edit Modifier Item" : "Add Modifier Item";

  return (
    <Modal
      isOpen={isModifierItemModalOpen}
      onClose={handleCloseModifierItemModal}
      title={modifierItemModalTitle}
      width="788px"
      maxWidth="788px"
      minWidth="10px"
      maxHeight="90dvh"
    >
      <ModifierItemForm
        modifierItemToEdit={modifierItemToEdit}
        handleCloseModifierItemModal={handleCloseModifierItemModal}
      />
    </Modal>
  );
};

export default ManageModifierItemModal;
